module.exports = "https://www.gc-qa.gnp.com.mx/de95d53b124692a289ba2cbff9417171.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pago-deducible-auto/consulta-cfdi/no-siniestros.svg
// module id = 8182
// module chunks = 0